import { Box } from '@mui/material';
import * as React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { colorTheme } from '../const';
import { useMediaQuery } from 'react-responsive'

export default function Tag(props) {
  const isMobileScreen = useMediaQuery({ query: '(max-width: 760px)' })

  const theme = createTheme({
    typography: {
      fontFamily: `'Noto Sans JP', 'Yu Gothic', 'Meiryo', 'Hiragino Sans', 'Arial', 'sans-serif'`,
    },
  });
  
  function tagBox(tagStyle, tagText) {
    return (
      <ThemeProvider theme={theme}>
      <span style={{ float: tagStyle === 'right' ? 'right' : 'left' }}>
        <Box sx={{
          display: 'inline-block',
          top: 0,
          //propsでrightを指定した場合とそれ以外の場合で余白が変化します
          padding: tagStyle === 'right' ? '10px 40px 10px 16px' : '10px 16px 10px 40px',
          width:{xs: '120px', sm: "150px", md: "190px", lg:"220px", xl: "250px"},
          height: {xs: '30px', sm: "40px", md: "50px", lg:"60px", xl: "70px"},
          lineHeight: {xs: '25px', sm: "24px", md: "30px", lg:"2.5vw", xl: "3vw"},
          //スマホの場合、画面サイズに合わせて文字のサイズが変化します
          fontSize: { xs: "16px", sm: "17px", md: "25px", lg:"1.5vw", xl: "1.8vw" },
          backgroundColor: `${colorTheme.palette.turquoiseBlue.main}`,
          color: 'white',
          whiteSpace: 'pre-line',
          fontWeight : "bold"
        }}>
          {tagText}
        </Box>
      </span>
      </ThemeProvider>
    )
  }
  return (
    <ThemeProvider theme={colorTheme}>
      {tagBox(props.tagStyle, props.tagText)}
    </ThemeProvider>
  )
}